import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoCestSchema } from '../types/ProdutoCest';

export type ApiProdutoCestGetParams = Partial<
    DefaultApiParams & {
        pesquisar: string;
    }
>;

const schema = registrosSchema(ProdutoCestSchema);

export function apiProdutoCestGet(params: ApiProdutoCestGetParams) {
    return fetchApi({
        endpoint: 'ProdutoCest/ProdutoCest',
        method: 'get',
        params,
        schema,
    });
}
